import { Box, Button, Card, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import brandLogo from '../../assets/Images/brandlogo.png'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ApiUsersLogin } from '../../apiService/Core/Apicall';
import { useDispatch } from 'react-redux';
import { setCanAccessOtp } from '../../global/config/Reducer/authSlice';
import PopupDialog from '../Popups/ConfirmDialog';


const Login: React.FC = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [errors, setErrors] = useState<{ email?: string; password?: string }>({});
    const [errorPopup, setErrorPopup] = useState<{ open: boolean; message: string }>({
        open: false,
        message: '',
    })
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        const newErrors: typeof errors = {};

        if (!email) {
            newErrors.email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            newErrors.email = "Enter a valid email";
        }

        if (!password) {
            newErrors.password = "Password is required";
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {
            console.log({ email, password });
            console.log({ email, password });

            try {
                const data = {
                    email,
                    password
                }
                const response = await ApiUsersLogin(data);
                if (response?.status) {
                    dispatch(setCanAccessOtp(true));
                    navigate('/otp', { state: { email, password } });
                    toast.success(response.message);
                }
            } catch (error: any) {
                console.error("Login error:", error);
                setErrorPopup({
                    open: true,
                    message: error?.message || error?.response?.data?.message || error || 'Something went wrong. Please try again.',
                })
            }

        }
    };

    return (
        <div className='container'>
            <Card className='login-card'>
                <Box className="col-5 p-5 login-brand-logo">
                    <img src={brandLogo} alt='#' />
                </Box>
                <Box className="col-12 col-xl-7 bg-dark-color p-xl-4 p-3">
                    <Box className="d-flex flex-column" gap={1}>
                        <Typography className='fs-18' color='#898989' fontWeight={600}>Sign in to Your Account</Typography>
                        <Typography className='fs-12' color='#898989'>Sign in to create, discover and connect with the global community</Typography>
                    </Box>
                    <Box component="form" onSubmit={handleSubmit} className="login-form">
                        <Box>
                            <Typography mb={0.5} color="#FFFFFF" fontSize="14px" fontWeight={500}>
                                Email
                            </Typography>
                            <TextField
                                fullWidth
                                placeholder="Enter the email"
                                variant="outlined"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                error={!!errors.email}
                                helperText={errors.email}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                            borderColor: "#898989",
                                        },
                                        "&:hover fieldset": {
                                            borderColor: "#898989",
                                        },
                                        "&.Mui-focused fieldset": {
                                            borderColor: "#cc583f",
                                            borderWidth: "1px",
                                        },
                                    },
                                    input: {
                                        padding: "12px",
                                        color: "#fff",
                                    },
                                }}
                            />
                        </Box>
                        <Box>
                            <Typography mb={0.5} color="#FFFFFF" fontSize="14px" fontWeight={500}>
                                Password
                            </Typography>
                            <TextField
                                fullWidth
                                type="password"
                                placeholder="Password"
                                variant="outlined"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                error={!!errors.password}
                                helperText={errors.password}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                            borderColor: "#898989",
                                        },
                                        "&:hover fieldset": {
                                            borderColor: "#898989",
                                        },
                                        "&.Mui-focused fieldset": {
                                            borderColor: "#cc583f",
                                            borderWidth: "1px",
                                        },
                                    },
                                    input: {
                                        padding: "12px",
                                        color: "#fff",
                                    },
                                }}
                            />
                        </Box>
                        <Button className='bg-orange text-white'
                            type="submit"
                            fullWidth
                            sx={{
                                fontWeight: 600,
                                textTransform: "none",
                                padding: "12px",
                                borderRadius: "8px",
                                "&:hover": {
                                    backgroundColor: "#e85c3e",
                                },
                            }}
                        >
                            Sign In
                        </Button>
                    </Box>
                </Box>
            </Card>
            <PopupDialog
                open={errorPopup.open}
                onClose={() => setErrorPopup({ open: false, message: '' })}
                onConfirm={() => setErrorPopup({ open: false, message: '' })}
                variant="error"
                title="Something Went Wrong"
                message={errorPopup.message}
                confirmText="Try Again"
                cancelText="Dismiss"
            />
        </div>
    )
}

export default Login
